// Port of api/fuel/app/classes/controller/api/monty/users/collection.php
import F from 'offline/filter/constants'
import CollectionFilter from 'offline/filter/collection'
import { runFilterEndpoint } from 'offline/api/monty'

export default function(params) {
	return runFilterEndpoint(CollectionFilter, params, F.OWNER_USER)
}
